import { defineStore } from 'pinia'
import { useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useUsersStore = defineStore('users', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getUsers: (state) => state.data?.data,
  },
  actions: {
    async indexUsers(params = {}) {
      try {
        console.log(params);
        const response = await axios.get('users', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createUser(params = {}) {
      try {
        const response = await axios.get('users/create', {params});
        return useCreateForm('users', response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showUser(userId, params = {}) {
      try {
        console.log('showUser');
        const response = await axios.get(`users/${ userId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editUser(userId, params = {}) {
      try {
        const response = await axios.get(`users/${ userId }/edit`, {params});
        return useEditForm(`users/${ userId }`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteUser(userId, params = {}) {
      try {
        const response = await axios.delete(`users/${ userId }`, {params});
        toasteventbus.emit('add', {
          summary: 'User Deleted',
          detail: `User has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
